import React, {Suspense} from 'react';
import {emitEventLog} from '@di-shared/features/analytics';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import {t} from '@di-shared/features/common/useInferableTranslation';
import DiagCpoRecall from '@di-shared/features/diag/cpo/recall/DiagCpoRecall';
import DiagCpoRecallLoading from '@di-shared/features/diag/cpo/recall/DiagCpoRecallLoading';
import {WebviewUtils} from '@shared/webviewUtils';

interface DiagCpoRecallPageProps {
  vin: string;
}

function linkToMaintenanceAppointment(vin: string) {
  WebviewUtils.openNewWebView({
    url: `${import.meta.env.VITE_CCI_DOMAIN}/maintenance/register/appointment?vin=${vin}`,
    isModal: true,
    isNavigationBar: true,
    isToolBar: false,
  });
}

function DiagCpoRecallPage({vin}: DiagCpoRecallPageProps) {
  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header left={<HeaderBackButton />}>
        <h1 className="title_xsmall_b nav_center_title">{t('T30384')}</h1>
      </Header>
      <main
        id="content"
        className="content page_car_management"
      >
        <Suspense fallback={<DiagCpoRecallLoading />}>
          <DiagCpoRecall vin={vin} />
        </Suspense>
      </main>

      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          onClick={() => {
            emitEventLog({
              event: 'di_vehicle_management',
              data_action: 'request inspection',
              data_name: t('T30372'),
            });
            linkToMaintenanceAppointment(vin);
          }}
        >
          {t('T30372')}
        </button>
      </div>
    </div>
  );
}

export default DiagCpoRecallPage;
